module.exports = __webpack_public_path__ + "static/media/editIcon.5f3fbf40.svg";